import { ChannelPayloadFilter, safeClone, SpyneTrait } from "spyne";
import { compose, filter, flatten, head, path, prop, propEq } from "ramda";
import { pascalCase } from "change-case";
import { UtilTraits } from "traits/util-traits";

export class CodeContainerTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "codeContainer$";

    super(context, traitPrefix);
  }

  static codeContainer$GetCodeBlockIdPayloadFilter(props = this.props) {
    const { codeBlockId } = props;

    return new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });
  }

  static codeContainer$GetContainerVsid(e = { srcElement: {} }) {
    const isContainerHolder = e.srcElement.id === "code-generator-holder";
    const isButton =
      e.srcElement.el !== undefined && e.srcElement.el.tagName === "BUTTON";

    let { vsid } = e.srcElement;
    //console.log("GET VSID ",{e,vsid,isButton})
    if (isButton === true) {
      //vsid =  //e.srcElement.el.closest('#code-generator-holder').dataset.vsid;
      //vsid =  e.srcElement.el.closest("#code-container").querySelector("#code-generator-holder").dataset.vsid
      vsid = e.srcElement.el.closest("#code-container").dataset.vsid;
    } else {
      vsid = document
        .querySelector(`[data-vsid="${e.srcElement.vsid}"`)
        .closest("#code-container").dataset.vsid;
    }

    return vsid;
  }

  static codeContainer$GetCodeExampleData(type, example) {
    const typePred = (o) =>
      String(o.type).toLowerCase() === String(type).toLowerCase();
    const examplePred = propEq(example, "name");
    //console.log('example is ', {type, example}, this.props.data);
    const filteredData = compose(
      safeClone,
      head,
      filter(examplePred),
      path([0, "states"]),
      filter(typePred),
      prop("types"),
    )(this.props.data);

    //console.log("FILTERED DATA ",{filteredData}, this.props.data);

    return filteredData;
  }

  static codeContainer$GetCreateChannelPayload(type, example, vsid = "00000") {
    if (String(type).toLowerCase() === "viewstream") {
      //type='ViewStream';
    }
    let typeId = type || "ViewStream";
    typeId = typeId === "404" ? "viewStream" : typeId;
    let exampleId = example || "instance";
    const data = this.codeContainer$GetCodeExampleData(typeId, exampleId);
    const { codeBlockId } = data;
    //console.log("TYPE ID IS ",{type,typeId});
    const methodSuffix = pascalCase("ViewStream") + pascalCase(exampleId);
    const filteredPayload = Object.assign(
      { codeBlockId },
      { data: safeClone(data) },
    );

    return data;
  }

  static codeContainer$GetChannelPayload(payloadProps = {}) {
    const {
      codeBlockId,
      methodName,
      codeBlockStateName,
      codeBlockDataSection,
      initialLoad,
      num,
      prevNum,
      sectionTitle,
    } = payloadProps;

    const data = this.codeContainer$GetCodBlockItemByIdAndMethodName(
      codeBlockId,
      methodName,
      this.props.data[codeBlockDataSection],
    );

    //const data2 = this.codeContainer$GetCodBlockItemByIdAndCodeBlockName(codeBlockId, codeBlockStateName,  this.props.data[codeBlockDataSection], methodName);

    //console.log("DATA IS ",{codeBlockId, methodName, codeBlockStateName, data, data2},  this.props.data[codeBlockDataSection])

    data["num"] = num;
    data["prevNum"] = prevNum;
    data["initialLoad"] = initialLoad;
    data.sectionTitle ??= sectionTitle;

    return data;
  }

  static codeContainer$ConformGenData(cGenData = { types }) {
    const codeGenData = safeClone(cGenData);
    let codeBlockDataSection = "types";

    const mapCodeBlockId = (cBlockData) => {
      const codeBlockData = safeClone(cBlockData);
      const { codeBlockId, menuLabel, type } = codeBlockData;
      let sectionNumIter = 0;
      let sectionNum;

      //console.log("cBLOCKDATA", cBlockData);

      const mapEachCodeBlockItem = (o, i) => {
        const obj = safeClone(o);
        obj["codeBlockId"] = codeBlockId;
        obj["codeBlockDataSection"] = codeBlockDataSection;
        obj["referenceClassName"] = menuLabel;
        obj["type"] = type;
        obj["sectionNum"] = sectionNum;
        obj["num"] = i;
        return obj;
      };

      const onMapEachState = (stateObj, i = 0) => {
        const isArray = UtilTraits.util$GetType(stateObj) === "array";
        sectionNum = sectionNumIter++;

        return isArray === true
          ? safeClone(stateObj).map(mapEachCodeBlockItem)
          : mapEachCodeBlockItem(stateObj, i);
      };

      codeBlockData.states = safeClone(codeBlockData.states).map(
        onMapEachState,
      );
      return codeBlockData;
    };

    //codeGenData.types =  safeClone(codeGenData.types).map(mapCodeBlockId);
    //codeGenData.reference =  safeClone(codeGenData.reference).map(mapCodeBlockId);

    for (const section in codeGenData) {
      if (section !== "modals") {
        codeBlockDataSection = section;
        console.log("codegen data is ",{codeBlockDataSection,codeBlockDataSection, codeGenData, mapCodeBlockId})
        codeGenData[codeBlockDataSection] =  codeGenData[codeBlockDataSection].map(mapCodeBlockId);
      }
      /* if (codeBlockDataSection !== 'types') {
          // Concatenate the elements of the array to the target property array
          codeGenData.types = codeGenData.types.concat(codeGenData[codeBlockDataSection]);
        }*/
    }

    return codeGenData;
  }

  static codeContainer$GetCodBlockById(
    codeBlockId,
    data = this?.props?.codeGenData,
  ) {

    if (data === undefined){
      return;
    }
    const pred = propEq(codeBlockId, "codeBlockId");

    //console.log("CODE BLICK AND DATA ", { codeBlockId, data });
    return compose(safeClone, head, filter(pred))(data);
  }
  static codeContainer$GetCodBlockItemByMethodName(
    methodName="",
    codeBlockData = {},
  ) {
    const pred = propEq(methodName, "methodName");

    return compose(head, filter(pred), flatten, prop("states"))(codeBlockData);
  }
  static codeContainer$GetCodBlockItemAndName(
    codeBlockStateName,
    codeBlockData = {},
  ) {
    const pred = propEq(codeBlockStateName, "codeBlockStateName");

    //console.log("GET BY NAME ",{codeBlockStateName, codeBlockData})

    return compose(head, filter(pred), flatten, prop("states"))(codeBlockData);
  }

  static codeContainer$GetCodBlockItemByIdAndCodeBlockName(
    codeBlockId,
    codeBlockStateName,
    data = this.props.codeGenData,
    methodName,
  ) {
    const codeBlockData = CodeContainerTraits.codeContainer$GetCodBlockById(
      codeBlockId,
      data,
    );

    //console.log("METHOD NAME CODEBLOCK ID METHODNAME",{methodName, codeBlockId, codeBlockData, data})

    return (
      CodeContainerTraits.codeContainer$GetCodBlockItemAndName(
        codeBlockStateName,
        codeBlockData,
      ) ??
      CodeContainerTraits.codeContainer$GetCodBlockItemByIdAndMethodName(
        codeBlockId,
        methodName,
        data,
      )
    );
  }

  static codeContainer$GetCodBlockItemByIdAndMethodName(
    codeBlockId,
    methodName,
    data = this.props.codeGenData,
  ) {
    //console.log("CODE BLCIK STUFF ", { codeBlockId, methodName, data });

    const codeBlockData = CodeContainerTraits.codeContainer$GetCodBlockById(
      codeBlockId,
      data,
    );

    //console.log("METHOD NAME CODEBLOCK ID METHODNAME",{methodName, codeBlockId, codeBlockData, data})

    return CodeContainerTraits.codeContainer$GetCodBlockItemByMethodName(
      methodName,
      codeBlockData,
    );
  }

  static codeContainer$HelloWorld() {
    //console.log("H W is test")
    return "Hello World";
  }

  static codeContainer$AddLineBrBetweenMethods(scriptText) {
    //return String(scriptText).replace(/(})(\n)(\s+)(\w)/gm, "$1\n\n$3$4")

    return scriptText;
  }

  static codeContainer$RemoveWebpackMetaFromScript(scriptText) {
    return String(scriptText).replace(
      /(.*)(__WEBPACK_IMPORTED_MODULE_\d__.)(.*)/g,
      "$1$3",
    );
  }

  static codeContainer$RemoveTemplateMetaFromScript(scriptText) {
    return String(scriptText).replace(
      /(__webpack_require__)(.*\/)([\w_\-.]+)("\))/gm,
      "$3$4",
    );
  }

  static codeContainer$UpdateScriptScring(scriptText) {
    const addLinesTxt =
      CodeContainerTraits.codeContainer$AddLineBrBetweenMethods(scriptText);
    return CodeContainerTraits.codeContainer$RemoveWebpackMetaFromScript(
      addLinesTxt,
    );
  }

  static codeContainer$ReturnScriptStringContent(scriptMethod, fnBool = true) {
    let content = scriptMethod(fnBool);
    const type = UtilTraits.util$GetType(content);

    let scriptString,
      scriptContentArr = [];

    const forEachScriptString = (o) => {
      o.scriptString =
        CodeContainerTraits.codeContainer$RemoveWebpackMetaFromScript(
          o.scriptString,
        );
      //o.scriptString = CodeContainerTraits.codeContainer$RemoveTemplateMetaFromScript(o.scriptString);
      return o;
    };

    const mapScriptString = (o) =>
      CodeContainerTraits.codeContainer$RemoveWebpackMetaFromScript(
        o.scriptString,
      );

    if (type === "array") {
      content = content.map(forEachScriptString);
      scriptString = content[0].scriptString;
      scriptContentArr = content;
    } else {
      scriptString =
        CodeContainerTraits.codeContainer$RemoveWebpackMetaFromScript(content);
    }
    return { scriptString, scriptContentArr };
  }

  static codeContainer$SendParseDataEvent(payload = {}) {
    /**
     * TODO: CHeck if scriptString is a string or object that contains scriptString
     *
     *
     * */

    const channel = "CHANNEL_CODE_GEN";
    const action = "CHANNEL_CODE_GEN_DATA_PARSE_REQUEST_EVENT";
    // const payload = {scriptString, vsid, codeBlockId};

    this.sendInfoToChannel(channel, payload, action);
  }
}
